/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Confirm_ButtonInputs */

const es_admin_billing_batch_confirm_button = /** @type {(inputs: Admin_Billing_Batch_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar y pagar`)
};

const en_admin_billing_batch_confirm_button = /** @type {(inputs: Admin_Billing_Batch_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm and pay`)
};

/**
* | output |
* | --- |
* | "Confirm and pay" |
*
* @param {Admin_Billing_Batch_Confirm_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_confirm_button = /** @type {((inputs?: Admin_Billing_Batch_Confirm_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Confirm_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_confirm_button(inputs)
	return en_admin_billing_batch_confirm_button(inputs)
});
export { admin_billing_batch_confirm_button as "admin.billing.batch.confirm_button" }